import * as ACTIONS from "@iso/redux/messages/actionTypes";

const initialState = {
  messages: {
    list: [],
    total: 0,
  },
};

function messagesReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_MESSAGES_SUCCESS: {
      return {
        ...state,
        ...{ messages: payload },
      };
    }

    default:
      return state;
  }
}

export default messagesReducer;
